let lastId: number = 1;

export default function generateUniqueId(prefix: string = ""): string {
    return `${prefix}${lastId++}`;
}

export function generateUniqueNumberId(): number {
    return lastId++;
}